(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["privilege-codes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPrivilegeCodes(section) {
    // "USE CODE" button – copy + flash
    section.querySelectorAll('.privilege-codes__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code');
        copyToClipboard(code);
        flashButton(btn);
      });
    });

    // "COPY CODE" link button
    section.querySelectorAll('.privilege-codes__copy').forEach(function (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code');
        var feedback = copyBtn.querySelector('.privilege-codes__copy-feedback');
        copyToClipboard(code).then(function () {
          showFeedback(feedback, 'Copied!');
        }).catch(function () {
          showFeedback(feedback, 'Copy failed');
        });
      });
    });
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // Fallback for older browsers / non-HTTPS
    return new Promise(function (resolve, reject) {
      var el = document.createElement('textarea');
      el.value = text;
      el.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0';
      document.body.appendChild(el);
      el.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(el);
      ok ? resolve() : reject();
    });
  }

  function flashButton(btn) {
    var original = btn.textContent;
    btn.textContent = 'Copied!';
    btn.style.opacity = '0.75';
    setTimeout(function () {
      btn.textContent = original;
      btn.style.opacity = '';
    }, 1500);
  }

  function showFeedback(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    setTimeout(function () {
      el.classList.remove('is-visible');
    }, 1800);
  }

  // Initial load
  document.querySelectorAll('[id^="privilege-codes-"]').forEach(initPrivilegeCodes);

  // Shopify Theme Editor live preview
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[id^="privilege-codes-"]');
      if (el) initPrivilegeCodes(el);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
